import React from 'react';
import { FadeIn } from './FadeIn';
export function CostOfNotBuying() {
  const rows = [{
    sin: '100 hs/año planificando desde cero',
    con: '10 min/semana. El resto es enseñar.'
  }, {
    sin: 'Repertorio repetido y desordenado',
    con: '6 tomos con progresión real'
  }, {
    sin: '60% de abandono en el primer año',
    con: 'Sistema de retención → +85%'
  }, {
    sin: 'Recital improvisado y caótico',
    con: 'Plan completo de 4 meses con cronograma'
  }, {
    sin: 'Teoría que el alumno odia',
    con: '40+ juegos lúdicos que pide'
  }, {
    sin: 'Honorarios bajos sin justificación',
    con: 'Marca + sistema visible que justifica subir 30-50%'
  }, {
    sin: 'Padres que cuestionan tu trabajo',
    con: 'Reporte trimestral que los convierte en aliados'
  }, {
    sin: 'Soledad del oficio sin guía',
    con: 'Manual de supervivencia con casos reales'
  }];
  return <section className="bg-navy-900 bg-grain py-24 relative overflow-hidden" data-id="element-20">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full bg-music-notes opacity-30 pointer-events-none" data-id="element-21"></div>

      <div className="container mx-auto px-6 content-relative" data-id="element-22">
        <FadeIn className="text-center max-w-4xl mx-auto mb-16" data-id="element-23">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-gold mb-4 tracking-widest" data-id="element-24">
            🎹 PIANO LISTO™
          </h2>
          <p className="font-accent italic text-xl md:text-2xl text-gray-300 mb-2" data-id="element-25">
            El próximo domingo podés seguir buscando en internet.
          </p>
          <p className="font-bold text-2xl md:text-3xl text-white mb-10" data-id="element-26">
            O podés tener todo resuelto desde hoy.
          </p>
          <h3 className="font-display font-bold text-3xl md:text-4xl text-white" data-id="element-27">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </FadeIn>

        <FadeIn delay={0.2} className="max-w-4xl mx-auto" data-id="element-28">
          <div className="bg-navy-800/80 backdrop-blur-md rounded-2xl border border-gold/20 overflow-hidden shadow-2xl" data-id="element-29">
            <div className="grid grid-cols-2 bg-navy-900 border-b border-gold/30" data-id="element-30">
              <div className="p-4 md:p-6 text-center font-bold text-gray-400 border-r border-gold/10" data-id="element-31">
                Sin Piano Listo
              </div>
              <div className="p-4 md:p-6 text-center font-bold text-gold" data-id="element-32">
                Con Piano Listo
              </div>
            </div>

            <div className="divide-y divide-white/5" data-id="element-33">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-white/5 transition-colors" data-id="element-34">
                  <div className="p-4 md:p-6 text-sm md:text-base text-gray-400 border-r border-white/5 flex items-center justify-center text-center" data-id="element-35">
                    {row.sin}
                  </div>
                  <div className="p-4 md:p-6 text-sm md:text-base text-white font-medium flex items-center justify-center text-center bg-gold/5" data-id="element-36">
                    {row.con}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}